const psData = {
    sources: [
    {
        "id": 1,
        "image": "ps-1"
    },
    {
        "id": 3,
        "image": "ps-2"
    },
    {
        "id": 4,
        "image": "ps-3"
    },
    {
        "id": 8,
        "image": "ps-4"
    },
    {
        "id": 9,
        "image": "ps-5"
    },
    {
        "id": 10,
        "image": "ps-6"
    },
    {
        "id": 12,
        "image": "ps-7"
    },
    {
        "id": 14,
        "image": "ps-8"
    },
    {
        "id": 16,
        "text": "Narrative of the Life of\nFrederick Douglass,\nAn\nAmerican Slave\n\nWritten by Himself\n\nWhat, ho! our countrymen in chains!\nThe whip on woman’s shrinking flesh!\nOur soil yet reddening with stains\nCaught from her scourging, warm and fresh!\nWhat! mothers from their children riven!\nWhat! God’s own image bought and sold!\nAmericans to market driven,\nAnd bartered as the brute for gold! - Whittier",
        "image": "ps-9"
    },
    {
        "id": 17,
        "text": "Dublin, Sept. 1, 1845\nDear Friend Garrison:\nThanks to a kind providence, I am now safe in old Ireland, in the beautiful city of Dubmin, surrounded by a kind family, and seated at the table of our mutual friend, James H. Webb, brother of the well known Richard D. Webb. I landed at Liverpool on Thursday morning 25th August, and took lodgings at the Union Hotel, Clayton Squire, in company with friend Buffum and our warm-hearted singers, the Hutchinson family. Here we all continued until Saturday evening, the 30th instant, when friend Buffum and myself (with no little reluctance) separated from them, and took ship for this place, and on our arrival here, were kindly invited by James, in the temporary absence of Richard D. Webb and family, to make his house our home.  \n\nThere are a number of things about which I should like to write, aside from those immediately connected with our cause; but of this I must deny myself, - at least under present circumstances. Sentimental letter writing must give way, when its claims are urged against facts necessary to the advancement of our cause and the destruction of slavery. I know it will gladden your heart to hear, that from the moment we first lost sight of the American shore, till we landed at Liverpool, our gallant steamship was the theatre of an almost constant discussion of the subject of slavery - commencing cool, but growing hotter every moment as it advanced. It was a great time for Anti-Slavery, and a hard time for slavery, - the one delighting in the sunshine of free discussion,",
        "image": "ps-10"
    },
    {
        "id": 19,
        "image": "ps-12"
    },
    {
        "id": 21,
        "image": "ps-13"
    },
    {
        "id": 22,
        "text": "Manuscript note of title page\n\"I think this little book is valuable, as giving a description of the first...Convention...of the kind that was ever held. Rhoda J. Palmer\" \n\nReport of the Woman's Right Convention\nHeld at Seneca Falls, N.Y., July 19th and 20th, 1848.\nRochester:\nPrinted by John Dick,at the North Star Office\n1848",
        "image": "ps-14"
    },
    {
        "id": 23,
        "image": "ps-54"
    },
    {
        "id": 24,
        "image": "ps-15"
    },
    {
        "id": 26,
        "image": "ps-16"
    },
    {
        "id": 27,
        "image": "ps-17"
    },
    {
        "id": 29,
        "image": "ps-18"
    },
    {
        "id": 30,
        "image": "ps-19"
    },
    {
        "id": 31,
        "image": "ps-20"
    },
    {
        "id": 32,
        "image": "ps-21"
    },
    {
        "id": 33,
        "image": "ps-22"
    },
    {
        "id": 34,
        "image": "ps-23"
    },
    {
        "id": 35,
        "image": "ps-24"
    },
    {
        "id": 36,
        "image": "ps-25"
    },
    {
        "id": 39,
        "image": "ps-26"
    },
    {
        "id": 41,
        "image": "ps-27"
    },
    {
        "id": 42,
        "image": "ps-28"
    },
    {
        "id": 44,
        "image": "ps-29"
    },
    {
        "id": 45,
        "text": "State of New York, Assembly Chamber, Jan. 10, 1865.\n\nDear Sir:\n\nThe use of the Assembly Chamber, was this morning granted to the Committee on Federal Relations, for the purpose of hearing an argument from you, in favor of the proposed amendment to the Constitution of the United States, prohibiting Slavery forever in the United States.\n\nIt gives me great pleasure to make this announcement to you, and to request, that you will, at your earliest convenience, favor the Committee, and through it, the Legislature of the State, with your views, upon this most important question: one that should engage the careful and earnest consideration of every Citizen.\n\nI am, very dear Sir, Very respectfully, Your obedient and humble servant,\n\nSAMUEL C. REED, Chairman Committee Federal Relations.\n\nGeneral Hiram Walbridge, New York.\n\nNew York, Jan. 12th, 1865.\n\nHon. Samuel C. Reed, Chairman Committee Federal Relations, Albany.\n\nDear Sir:\n\nI am profoundly grateful to the Committee of Federal Relations, in the Assembly, for the unexpected distinction they have awarded me, (as I have just learned by your favor of the 10th inst.,) in expressing a wish to hear me on the proposed amendment of the Federal Constitution, for ever interdicting Slavery in the “United States.”\n\nI sincerely believe there can be no permanent tranquility in this country while the Institution of Slavery exists; and that it is wise and prudent to secure its eradication from our political system, by peaceful and constitutional means. This will be accomplished by the success of the proposed amendment.\n\nAt as early a day as practicable, (consistent with my existing engagements,) I will address you again, and designate the time when I shall be at liberty to avail myself of the very great compliment your Committee has extended to me.\n\nFor the kind and generous manner in which you have communicated the action of your body, I beg you to accept my sincere and cordial thanks.\n\nYours sincerely, HIRAM WALBRIDGE.\n\nFit screenZoom outZoom inRotate rightFull expandPrevNext\nDownload\n\nPDF ( all pages )\nGo\nAbout ",
        "image": "ps-30"
    },
    {
        "id": 47,
        "image": "ps-30b"
    },
    {
        "id": 48,
        "image": "ps-31"
    },
    {
        "id": 49,
        "text": "Transcript\nAMENDMENT XIV\n\nSection 1.\nAll persons born or naturalized in the United States, and subject to the jurisdiction thereof, are citizens of the United States and of the State wherein they reside. No State shall make or enforce any law which shall abridge the privileges or immunities of citizens of the United States; nor shall any State deprive any person of life, liberty, or property, without due process of law; nor deny to any person within its jurisdiction the equal protection of the laws.",
        "image": "ps-32"
    },
    {
        "id": 50,
        "image": "ps-33"
    },
    {
        "id": 52,
        "text": "Harper's Weekly\nA Journal of Civilization\nNew York, Saturday, November 16, 1867\n\"The First Vote\"",
        "image": "ps-34"
    },
    {
        "id": 53,
        "image": "ps-35"
    },
    {
        "id": 54,
        "text": "Transcription\n\n\"The manner of using these papers was this: A slave nearly or sufficiently answering the description set forth in the papers, would borrow or hire them till he could by their means escape to a free State, and then, by mail or otherwise, return them to the owner. The operation was a hazardous one for the lender as well as the borrower. A failure on the part of the fugitive to send back the papers would imperil his benefactor, and the discovery of the papers in possession of the wrong man would imperil both the fugitive and his friend. It was therefore an act of supreme trust on the part of a freeman of color thus to put in jeopardy his own liberty that another might be free. It was, however, not unfrequently bravely done, and was seldom discovered. I was not so fortunate as to sufficiently resemble any of my free acquaintances as to answer the description of their papers.\n\nBut I had one friend--a sailor--who owned a sailor's protection, which answered somewhat the purpose of free papers-- describing his person, and certifying to the fact that he was a free American sailor. The instrument had at its head the American eagle, which gave it the appearance at once of an authorized document. This protection did not, when in my hands, describe its bearer very accurately. Indeed, it called for a man much darker than myself, and close examination of it would have caused my arrest at the start. In order to avoid this fatal scrutiny on the part of the railroad official, I had arranged with Isaac Rolls, a hackman, to bring my baggage to the train just on the moment of its starting, and...\"",
        "image": "ps-36"
    },
    {
        "id": 56,
        "image": "ps-37"
    },
    {
        "id": 57,
        "image": "ps-38"
    },
    {
        "id": 58,
        "text": "Resolutions of Respect\n\nTrustee's Department Metropolitan A.M.E. Church, Washington, D.C., March 12, 1895.\n\nAt the regular monthly meeting of \nthe Board of Trustees, Metropolitan A.M.E. \nChurch, M St., between 15th and 16th, N.W., the \nfollowing preamble and resolutions were \nunanimously adopted: \n\nResolved - The Board of Trustees of the \nMetropolitan A.M.E. Church do express \ntheir profound sorrow at the demise of the \n~ Hon. Frederick Douglass, ~ \nfor so many years a member of its congregation \nand one of it stanchest and most \nliberal friends; and, that a copy of this\nresolution be engrossed and sent to the\nfamily of the deceased. ",
        "image": "ps-39"
    },
    {
        "id": 59,
        "text": "Past National Presidents of the National Association of Colored Women's Clubs ",
        "image": "ps-40"
    },
    {
        "id": 60,
        "image": "ps-41"
    },
    {
        "id": 62,
        "image": "ps-42"
    },
    {
        "id": 64,
        "image": "ps-43"
    },
    {
        "id": 65,
        "image": "ps-44"
    },
    {
        "id": 66,
        "text": "The Bridgeport times and evening farmer., August 26, 1920. \n\nWomen of the Nation Get the Ballot\n\nWashington, Aug. 26 The proclamation announcing officially that the suffrage amendment to the constitution has been ratified was signed today by Secretary of State Colby. The document was signed at 8 o'clock this morning at Mr. Colby's home when the certificate from Governor Roberts that the Tennessee legislature had ratified the amendment was received. Secretary Colby announced his action on his arrival at his office later. The announcement disappointed a group of suffrage workers who had gathered at the State Department hoping to be present when Mr. Colby signed. Miss Alice Paul, Chairman of the National Woman's Party, was among them.\n\n\"We are confident that the signature of Secretary Colby completes the suffrage struggle in this country,\" she said. \"The woman's party will not relax its vigilance, however, until it is satisfied that no further attempts will be made to wrest from the woman of the United States the political equity which they have won.\"",
        "image": "ps-45"
    },
    {
        "id": 68,
        "image": "ps-46"
    },
    {
        "id": 70,
        "image": "ps-47"
    },
    {
        "id": 71,
        "image": "ps-48"
    },
    {
        "id": 73,
        "image": "ps-50"
    },
    {
        "id": 75,
        "image": "ps-51"
    },
    {
        "id": 77,
        "image": "ps-53"
    },
    {
        "id": 78,
        "image": "ps-78"
    },
    {
        "id": 79,
        "image": "ps-55"
    },
    {
        "id": 80,
        "image": "ps-56"
    },
    {
        "id": 81,
        "image": "ps-57"
    }
    ]
}

export default psData;